import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-pending-approval',
  templateUrl: './pending-approval.component.html',
  styleUrls: ['./pending-approval.component.css']
})
export class PendingApprovalComponent implements OnInit {

  customerInfo: any = []
  singleCustomerInfo: any= []
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  first: number = 0
  tableSizes: any = [3, 6, 9, 12];
  customerData: any = [];
  buttonDisable = false
  buttonDisable1 = false

  isLoading: any = false

  actionControls: any = {
    isAdd: false, 
    isView: false, 
    isDelete: false, 
    isModify: false 
  }

  constructor(private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {

  let href:any = window.location.href;
  let messages = href.split('/') 
  let action: any = this.generic_service.checkActionControls(messages[messages.length-1])
  this.actionControls = action
    this.pendingforAprroval()
  }

  onTableDataChange(event: any) {
    this.page = event;
    console.log(event)
    this.pendingforAprroval();
  }
  onTableSizeChange(event: any): void {
    console.log(event)

    this.tableSize = event.target.value;
    this.page = 1;
    this.pendingforAprroval();
  }



  pendingforAprroval(){
    this.isLoading = true

    let body = {
      "pageNumber": this.page-1,
      "recordsPerPage": 10,
      "key": "REQUESTED"
    }

    console.log(body)
    this.generic_service.pendingForApproval(body).subscribe(
      (response:any) => {
        console.log(response)
        this.customerData = response.response.customerInfoList
        this.count = response.response.totalRecords
        this.isLoading = false

      },
      (error:any)=>{
        console.log(error)
      }
    )
  }


  cancelModel(){
    document.getElementById("closeModalButton4")?.click()
  }


  getCustomerInfoById(id:any){
    this.generic_service.getCustomerInfoById(id).subscribe(
      (res:any)=>{
        console.log(res)
        this.singleCustomerInfo = []
        this.singleCustomerInfo.push(res.response)
      },
      (err:any)=> {
        console.log(err)
      }
    )
  }

  approveCustomerInfo(){
    this.buttonDisable = true

    let body = {
        "id": this.singleCustomerInfo[0].customerInfoId,
        "cid": Number(sessionStorage.getItem('cid')),
        "customerRegistrationStatusDTO": {
          "customerRegistrationStatus": "APPROVED",
          "updatedDate": new Date().getTime()
        }
    }
    console.log(body)
    this.generic_service.approveCustomerInfo(body).subscribe(
      (res:any)=>{
        console.log(res)
        this.pendingforAprroval();
        this.toastr.success("Successfully approved")
        this.cancelModel();
        this.buttonDisable = false
      },
      (err:any)=>{
        console.log(err)
        this.toastr.error(err.error.errors[0].description)
        this.buttonDisable = false
      }
    )
  }

  rejectCustomerInfo(){
    this.buttonDisable1 = true

    let body = {
        "id": this.singleCustomerInfo[0].id,
        "cid": Number(sessionStorage.getItem('cid')),
        "customerRegistrationStatusDTO": {
          "customerRegistrationStatus": "REJECTED",
          "updatedDate": new Date().getTime()
        }
    }
    console.log(body)
    this.generic_service.rejectCustomerInfo(body).subscribe(
      (res:any)=>{
        console.log(res)
        this.pendingforAprroval();
        this.toastr.success("Successfully rejected")
        this.cancelModel()
        this.buttonDisable1 = false

      },
      (err:any)=>{
        console.log(err)
        this.toastr.error(err.error.errors[0].description)
        this.buttonDisable1 = false
      }
    )
  }

 
}